export default "__VITE_ASSET__DOqf9toA__"